module.exports = __webpack_public_path__ + "img/disaster_relief-stage_3.5.c809eca4.jpg";